module.exports = __webpack_public_path__ + "static/media/header.ab188b67.png";